/* eslint-disable react-hooks/exhaustive-deps */
import {
  FunctionComponent,
  useEffect,
  useState,
  useCallback,
  useRef,
} from 'react'
import { useHistory } from 'react-router-dom'
import { Grid } from '@material-ui/core'

import Buscar from 'shared/components/Buscar'
import { IValueBuscar } from 'shared/components/Buscar/BuscarComponent.types'
import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import SnackBar from 'shared/components/SnackBar'
import ContainerPage from 'shared/components/ContainerPageNew'
import Pagination from 'shared/components/Pagination'
import { colors } from 'shared/styles/colors'
import Table from 'shared/components/Table'
import { useFrotista } from 'modules/user/hooks/useFrotista'

import IFindAllMotoristaRequest from 'modules/motorista/domain/entities/IFindAllMotoristasRequest'
import { IFindByCpfNomeFrotistaId } from 'modules/motorista/domain/usecases/FindByCpfNomeFrotistaId'
import { StyledGrid } from './styles'

type TProp = {
  findByCpfNomeFrotistaId: IFindByCpfNomeFrotistaId
}

const ListMotoristas: FunctionComponent<TProp> = ({
  findByCpfNomeFrotistaId,
}) => {
  const history = useHistory()
  const [motoristas, setMotoristas] = useState(null)
  const [errorMessage, setErrorMessage] = useState('')
  const [error, setError] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [recordsPerPage, setRecordsPerPage] = useState(10)
  const [search, setSearch] = useState(null)
  const { frotistaId } = useFrotista()

  const handleView = motorista => {
    history.push('/vale-pedagio/viagens', { documento: motorista.cpf })
  }

  const [loading, setLoading] = useState(false)
  const inputMotoristaRef = useRef(null)
  const handleGetMotoristas = useCallback(
    (query: IFindAllMotoristaRequest) => {
      return findByCpfNomeFrotistaId.execute(query)
    },
    [findByCpfNomeFrotistaId],
  )
  const fetchMotoristas = async (page: number, search: string) => {
    setSearch(search)
    setLoading(true)
    try {
      const response = await handleGetMotoristas({
        page,
        perPage: 10,
        nome: search,
        list_status: ['VALID', 'MANUAL_APPROVAL'],
        frotista_id: frotistaId ? Number(frotistaId) : undefined,
      })
      const newMotoristas = response.data.map(item => {
        return {
          ...item,
          handleView: () => handleView(item),
        }
      })
      setMotoristas(newMotoristas)
      setTotalRecords(response.total)
      setRecordsPerPage(response.per_page)
      setLoading(false)
    } catch (err: unknown) {
      setError(true)
      if (err instanceof Error) {
        setErrorMessage(err.message)
      } else {
        setErrorMessage('Erro buscar motoristas')
      }
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchMotoristas(currentPage, search)
  }, [currentPage, search, frotistaId])

  const handleSearch = async (values: IValueBuscar) => {
    setCurrentPage(1)

    values.valueInput !== '' ? setSearch(values.valueInput) : setSearch(null)
  }

  return (
    <>
      {loading && <LoadingBackdrop open={loading} color={colors.green} />}
      <ContainerPage
        breadCrumb="Vale Pedágio / Lista de motoristas"
        showFooterScaffold={false}
        title="Lista de motorista(s)"
      >
        <Grid container>
          <Grid item xs={12}>
            <Buscar
              handleSubmit={handleSearch}
              inputBuscarRef={inputMotoristaRef}
              placeholder="Digite o nome para buscar"
              label="Buscar motorista"
              loading={loading}
            />
          </Grid>
        </Grid>
        <StyledGrid container>
          <Grid item xs={12}>
            {motoristas && (
              <Table data={motoristas} type="vale_pedagio_motorista" />
            )}
          </Grid>
          <Grid item xs={12}>
            <SnackBar
              open={error}
              setOpen={setError}
              severity="error"
              message={errorMessage}
              horizontal="right"
            />
          </Grid>
        </StyledGrid>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          recordsPerPage={recordsPerPage}
          setCurrentPage={setCurrentPage}
        />
      </ContainerPage>
    </>
  )
}

export default ListMotoristas
